import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  return (
    <div className="navbar-main">
      <nav className="navbar navbar-expand-lg fixed-top ">
        <Link to="/">
          <img
            src="../images/tamizhtechielogo.png"
            className=""
            alt="tamizhtechielogo"
          />{" "}
        </Link>

        <button
          className="navbar-toggler uarr collapsed"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">
                முகப்பு
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/category/" + "trending"}>
                ட்ரெண்டிங்
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/category/" + "gadget"}>
                கேஜெட்டுகள்
              </Link>
            </li>
            <li className="nav-item ">
              <Link className="nav-link" to={"/category/" + "techietalks"}>
                TechieTalks
              </Link>
            </li>
            <li className="nav-item ">
              <Link className="nav-link" to={"/category/" + "udemycoupons"}>
                Udemy Coupons
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to={"/category/" + "developerzone"}>
                Developer Zone
              </Link>
            </li>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Our Tools
              </a>
              <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                <a class="dropdown-item" href="/PrivacyPolicyGenerator">
                  Privacy Policy Generator
                </a>
              </div>
            </li>

            <li className="nav-item ">
              <a
                className="nav-link "
                href="https://www.studentsjob.in/"
                target="_blank"
              >
                JobSearch
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
